module.exports = __webpack_public_path__ + "img/grue.606048f2.jpg";